import { jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { forwardRef } from "react";
const CloseIconInner = (props, ref) => {
  return /* @__PURE__ */ jsx(
    SvgIcon,
    {
      ...props,
      ref,
      children: /* @__PURE__ */ jsx(
        "svg",
        {
          fill: "currentColor",
          height: "48",
          stroke: "currentColor",
          viewBox: "0 -960 960 960",
          width: "48",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ jsx("path", { d: "m250.923-218.924-31.999-31.999L448.001-480 218.924-709.077l31.999-31.999L480-511.999l229.077-229.077 31.999 31.999L511.999-480l229.077 229.077-31.999 31.999L480-448.001 250.923-218.924Z" })
        }
      )
    }
  );
};
const CloseIcon = forwardRef(CloseIconInner);
export {
  CloseIcon
};
